import React from 'react';
import { AclPermissionsRole } from '@eventmanager/types';
import { c, toTitleCase } from '../../utils';

import classes from './PlanBadge.module.scss';

type CurrentPlanProps = {
  label: AclPermissionsRole | undefined;
};

// Map specific plan levels to their respective brand colors.
const planColorMap = {
  office: 'bg-color-logo-green--dark',
  admin: 'bg-color-blue-delight',
  starter: 'bg-color-logo-green',
  pro: 'bg-color-logo-blue',
  enterprise: 'bg-color-violet',
};

// [2026-03-08] Render a visual badge for the user's current plan.
// Displays a star icon and the plan name (e.g., "Starter", "Pro") in title case.
export function PlanBadge({ label }: CurrentPlanProps) {
  return (
    <span className={c(classes.PlanBadge, planColorMap[label || ''])}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2l2.9 6.3 6.9.6-5.2 4.5 1.6 6.7L12 16.9 5.8 20l1.6-6.7L2.2 8.9l6.9-.6L12 2z" />
      </svg>
      {toTitleCase(label || '')}
    </span>
  );
}
